<template>
  <div class="faq-list">
    <div
      v-for="(faqsInCategory, category) in faqsMapped"
      :key="category"
      class="faq-category"
    >
      <h3 class="category-title">
        {{ categoryLabels[category] }}
      </h3>
      <div class="faqs">
        <div
          v-for="faq in faqsInCategory"
          :key="faq.id"
          :class="{ expanded: isExpanded(faq) }"
          class="faq"
        >
          <div class="faq-heading">
            <div
              class="faq-heading-content"
              @click="toggleExpand(faq)"
            >
              <h4 class="faq-text">
                {{ faq.title }}
              </h4>
              <div class="faq-expand-icon">
                <chevron-right />
              </div>
            </div>
            <node-element-local-tasks
              :itemid="faq.id"
              :options="{ mode: 'view', destination: '/faqs' }"
            />
          </div>
          <div
            v-if="isExpanded(faq)"
            class="faq-content"
          >
            <div
              class="faq-body"
              v-html="faq.body"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronRight from './chevron-right'

export default {
  name: 'faq-list',
  components: {
    ChevronRight
  },
  props: {
    faqs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      expanded: {}
    }
  },
  computed: {
    faqsMapped() {
      return this.faqs.reduce((acc, faq) => {
        if (acc[faq.category] == null) {
          acc[faq.category] = []
        }
        acc[faq.category].push(faq)
        return acc
      }, {})
    },
    categoryLabels() {
      return Object.keys(this.faqsMapped).reduce((acc, id) => {
        acc[id] = this.$store.getters['config/getTermLabelFromEnum'](id)
        return acc
      }, {})
    }
  },
  methods: {
    isExpanded(faq) {
      return !!this.expanded[faq.id]
    },
    toggleExpand(faq) {
      this.$set(this.expanded, faq.id, !this.expanded[faq.id])
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.faq-list {
  .faq-category {
    &:not(:last-child) {
      margin-bottom: 3em;
    }
    .category-title {
      margin-bottom: 0.5em;
    }
    .faqs {
      .faq {
          margin: 0.5em 0em;
          padding: 0.5em 0em;
          border-top: 1px solid;
          border-color: var(--main-border-color);

        &.expanded {
          .faq-heading {
            .faq-heading-content {
              .faq-expand-icon {
                transform: rotateZ(90deg);
              }
            }
          }
        }
        .faq-heading {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .faq-heading-content {
            flex-grow: 1;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .faq-text {
              margin-bottom: 0;
              word-break: break-all;
              word-break: break-word;
              margin-right: 1em;
              color: var(--main-link-color);
            }
            .faq-expand-icon {
              transition: transform .2s ease-in-out;
              flex-shrink: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 2.5em;
              height: 2.5em;
              svg {
                width: 70%;
                height: 70%;
                fill: var(--main-link-color);
              }
            }
            &:hover {
              .faq-text {
                color: var(--main-link-hover-color);
              }
              .faq-expand-icon {
                svg {
                  fill: var(--main-link-hover-color);
                }
              }
            }
          }
          .page-options {
            top: -0.1em;
            right: -3.5em;
          }
        }
        .faq-content {
          margin-top: 1em;
          padding: 0 2em;
          .faq-body {
            word-break: break-all;
            word-break: break-word;
          }
        }
      }
    }
  }
}
</style>
